
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

export const ProfileBreadcrumbs = () => {
  const { t } = useTranslations("profile");
  const { getPath } = useLanguagePath();
  
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80">
            {t("breadcrumbs.dashboard")}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage className="font-medium">{t("breadcrumbs.profile")}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};
